import { render, staticRenderFns } from "./HotData.vue?vue&type=template&id=47c034c2&scoped=true&"
import script from "./HotData.vue?vue&type=script&lang=js&"
export * from "./HotData.vue?vue&type=script&lang=js&"
import style0 from "./HotData.vue?vue&type=style&index=0&id=47c034c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c034c2",
  null
  
)

export default component.exports